import getContext from './getContext';
export default function getGAClientId() {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$timeout = _ref.timeout,
    timeout = _ref$timeout === void 0 ? 4000 : _ref$timeout;
  return new Promise((resolve, reject) => {
    const context = getContext();
    if (typeof context.ga !== 'function') {
      reject(new Error('getGAClientId: there is no ga() to get the client id.'));
      return;
    }
    const tid = setTimeout(() => {
      reject(new Error('getGAClientId: Timed out waiting for client id from ga()'));
    }, timeout);
    context.ga(tracker => {
      clearTimeout(tid);
      try {
        resolve(tracker.get('clientId'));
      } catch (err) {
        reject(err);
      }
    });
  });
}